import { render, staticRenderFns } from "./new-user-management-guidelines.vue?vue&type=template&id=41b4852a&scoped=true&"
import script from "./new-user-management-guidelines.vue?vue&type=script&lang=js&"
export * from "./new-user-management-guidelines.vue?vue&type=script&lang=js&"
import style0 from "./new-user-management-guidelines.vue?vue&type=style&index=0&id=41b4852a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b4852a",
  null
  
)

export default component.exports